/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-15T11:07:06.87
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentHouseSalesCardEditInit,
	getRentHouseSalesCardView
} from '@api/rentmanage/RentHouseSalesCard';

import {
listRentHouseSalesCardConsumeInit,
listRentHouseSalesCardConsumeByAuthorizations,
deleteRentHouseSalesCardConsume
} from '@api/rentmanage/RentHouseSalesCardConsume';

import {
listCardOperationLogInit,
listCardOperationLogByAuthorizations,
deleteCardOperationLog
} from '@api/rentmanage/CardOperationLog';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getRentHouseSalesCardEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseSalesCardEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHouseSalesCardView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseSalesCardView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
